// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'viagens.title': 'Viagens',
    'viagens.eyebrow': 'Logística',
    'viagens.toggle.dia': 'Dia ao vivo',
    'viagens.toggle.historico': 'Histórico',
    'viagens.kpi.total': 'Viagens',
    'viagens.kpi.atendidas': 'Atendidas',
    'viagens.kpi.naoAtendidas': 'Não atendidas',
    'viagens.kpi.emAndamento': 'Em andamento',
    'viagens.kpi.desvios': 'Desvios',
    'viagens.kpi.semVinculo': 'Sem carga no HUB',
    'viagens.kpi.semVinculoHint': 'Viagens do Protheus sem carga equiparada no HUB, e por isso sem medida',
    'viagens.kpi.km': 'Km rodados',
    'viagens.kpi.kmHint': 'Distância GPS das viagens medidas, só em trânsito. Descarregando não conta quilômetro',
    'viagens.kpi.transito': 'Trânsito médio',
    'viagens.kpi.transitoHint': 'Da saída da origem à chegada ao destino, só viagens com o trânsito fechado',
    'viagens.kpi.descarga': 'Descarga média',
    'viagens.kpi.descargaHint': 'Da chegada à liberação na unidade, fora as descargas suspeitas e as fechadas em lote',
    'viagens.kpi.ciclo': 'Ciclo médio',
    'viagens.kpi.cicloHint': 'Da escala ao Atendido, só viagens atendidas',
    'viagens.kpi.nfNoPrazo': 'Solicitação de NF no prazo',
    'viagens.kpi.nfNoPrazoHint': 'Notas pedidas até a saída da fazenda, sobre {{count}} viagens medidas',
    'viagens.kpi.semMedida': 'Sem medida',
    'viagens.filtros.todos': 'Todos',
    'viagens.filtros.de': 'De',
    'viagens.filtros.ate': 'Até',
    'viagens.filtros.busca': 'Viagem, carga, motorista, cliente…',
    'viagens.filtros.buscaLabel': 'Busca',
    'viagens.filtros.cliente': 'Cliente',
    'viagens.filtros.contrato': 'Contrato',
    'viagens.filtros.dupla': 'Dupla',
    'viagens.filtros.motorista': 'Motorista',
    'viagens.filtros.servico': 'Serviço',
    'viagens.col.servico': 'Serviço',
    'viagens.servico.sem': 'Sem serviço',
    'viagens.servico.descricaoErp': 'Descrição no ERP',
    'viagens.servico.semDescricao': 'A viagem veio do ERP sem descrição de serviço',
    'viagens.servico.naoAlocada': 'Ainda não alocada a um serviço em Cadastros',
    'viagens.servico.porPadrao': 'Sem alocação em Cadastros. A viagem sai no serviço padrão.',
    'viagens.filtros.statusHub': 'Status HUB',
    'viagens.filtros.statusErp': 'Status ERP',
    'viagens.filtros.hojeHint': 'O dia ao vivo é sempre hoje',
    'viagens.col.data': 'Data',
    'viagens.col.dataHub': 'Data HUB',
    'viagens.col.dataErp': 'Data ERP',
    'viagens.data.semHub': 'Viagem sem registro no HUB. O período usa a Data ERP',
    'viagens.col.frenteContrato': 'Frente e contrato',
    'viagens.col.frente': 'Frente',
    'viagens.col.motorista': 'Motorista',
    'viagens.col.placa': 'Placa',
    'viagens.col.carreta': 'Carreta',
    'viagens.col.statusHub': 'Status HUB',
    'viagens.col.statusErp': 'Status ERP',
    'viagens.col.viagemErp': 'Viagem ERP',
    'viagens.col.tempoUbs': 'Tempo UBS',
    'viagens.ubs.preenchido': 'Preenchido',
    'viagens.ubs.pendente': 'Pendente',
    'viagens.ubs.nao_se_aplica': 'Não se aplica',
    'viagens.ubs.dica.preenchido': 'O Protheus já tem o Tempo UBS desta viagem.',
    'viagens.ubs.dica.pendente': 'O Protheus não tem um Tempo UBS válido para esta viagem. Ela entra no arquivo de Tempo UBS quando a descarga estiver medida até o Disponível.',
    'viagens.ubs.dica.nao_se_aplica': 'Só a viagem de Espiga tem Tempo UBS.',
    'viagens.arquivo.tempo_ubs.rotulo': 'Gerar CSV Tempo UBS',
    'viagens.arquivo.tempo_ubs.dica_one': 'Leva {{count}} viagem de Espiga atendida no HUB, com o Tempo UBS vazio no Protheus e a descarga medida até o Disponível.',
    'viagens.arquivo.tempo_ubs.dica_other': 'Leva {{count}} viagens de Espiga atendidas no HUB, com o Tempo UBS vazio no Protheus e a descarga medida até o Disponível.',
    'viagens.arquivo.tempo_ubs.vazio': 'Nenhuma viagem do filtro é de Espiga atendida no HUB, com o Tempo UBS vazio no Protheus e a descarga medida até o Disponível.',
    'viagens.arquivo.apontamento.rotulo': 'Gerar CSV Apontamento de Viagem',
    'viagens.arquivo.apontamento.dica_one': 'Leva {{count}} viagem de Espiga em aberto no Protheus e descarregando ou atendida no HUB.',
    'viagens.arquivo.apontamento.dica_other': 'Leva {{count}} viagens de Espiga em aberto no Protheus e descarregando ou atendidas no HUB.',
    'viagens.arquivo.apontamento.vazio': 'Nenhuma viagem do filtro é de Espiga em aberto no Protheus e descarregando ou atendida no HUB.',
    'viagens.arquivo.jaGeradas_one': '{{count}} delas já saiu em arquivo, o último gerado por {{quem}} em {{quando}}. O Protheus ainda não devolveu o dado.',
    'viagens.arquivo.jaGeradas_other': '{{count}} delas já saíram em arquivo, o último gerado por {{quem}} em {{quando}}. O Protheus ainda não devolveu o dado.',
    'viagens.arquivo.jaGeradasSemAutor_one': '{{count}} delas já saiu em arquivo, o último gerado em {{quando}}. O Protheus ainda não devolveu o dado.',
    'viagens.arquivo.jaGeradasSemAutor_other': '{{count}} delas já saíram em arquivo, o último gerado em {{quando}}. O Protheus ainda não devolveu o dado.',
    'viagens.col.destino': 'Destino',
    'viagens.col.dupla': 'Dupla',
    'viagens.col.transito': 'Trânsito',
    'viagens.col.descarga': 'Descarga',
    'viagens.col.ciclo': 'Ciclo',
    'viagens.col.kmVazio': 'KM vazio',
    'viagens.col.kmCarregado': 'KM carregado',
    'viagens.col.kmErp': 'KM Protheus',
    'viagens.col.otimizacao': 'Otimização',
    'viagens.km.semOtimizacao': 'Sem otimização',
    'viagens.km.semOtimizacaoDica': 'Falta o KM Protheus ou o KM vazio desta viagem.',
    'viagens.km.vazioSemMedida': 'O KM vazio é o que o caminhão rodou do Disponível da viagem anterior até entrar em Trânsito, passando por Adiantando, Escalado e Carregando. Fora o tempo em Folga, Manutenção ou Outros Serviços. Sem medida quando o rastreador não mandou posição.',
    'viagens.km.erpDiferenca': 'Carregado real {{real}}, diferença {{delta}}',
    'viagens.km.erpSemComparacao': 'Sem KM carregado medido para comparar',
    'viagens.kpi.otimizacao': 'Otimização de KM',
    'viagens.kpi.otimizacaoDica': '{{n}} viagens com KM Protheus e KM vazio medidos',
    'viagens.otimizacao.titulo': 'Otimização de KM',
    'viagens.otimizacao.amostra': '{{count}} viagens medidas',
    'viagens.otimizacao.protheus': 'KM Protheus',
    'viagens.otimizacao.vazioRotulo': 'KM vazio',
    'viagens.otimizacao.pendentes': 'Viagens sem medida ainda',
    'viagens.otimizacao.negativo': 'Rodou vazio mais do que o Protheus paga.',
    'viagens.otimizacao.rodape': 'Otimização é o KM Protheus menos o KM vazio. Vazio é o que o caminhão rodou em Adiantando, Escalado e Carregando, até entrar em Trânsito.',
    'viagens.otimizacao.vazio': 'Nenhuma viagem do período tem o KM Protheus e o KM vazio medidos.',
    'viagens.col.notaFiscal': 'Solicitação de NF',
    'viagens.col.emissaoNf': 'Emissão NF',
    'viagens.nf.noPrazo': 'Dentro do prazo',
    'viagens.grupo.composicao': 'Composição',
    'viagens.grupo.status': 'Status da viagem',
    'viagens.grupo.medidas': 'Medidas',
    'viagens.vazio': 'Nenhuma viagem neste recorte.',
    'viagens.relatorio.title': 'Relatório',
    'viagens.relatorio.hint': 'Tempos só das etapas fechadas. Quilômetro das etapas em curso é medido até agora. Travessão é sem medida, não zero.',
    'viagens.relatorio.count': '{{count}} viagens',
    'viagens.relatorio.ocultas': '{{count}} sem motorista e sem placa ficam fora da tabela',
    'viagens.bloco.statusHub': 'Status HUB',
    'viagens.bloco.statusHubCentro': 'viagens',
    'viagens.bloco.statusErp': 'Status ERP',
    'viagens.bloco.semStatus': 'Sem status',
    'viagens.bloco.curvas': 'Viagens por dia',
    'viagens.bloco.curvasHint': 'Pela data prevista da viagem. De baixo para cima, atendidas, em andamento de Escalado a Descarregando, não atendidas e sem status, que são as viagens do Protheus sem carga no HUB.',
    'viagens.bloco.rankingDuplas': 'Viagens por dupla',
    'viagens.bloco.rankingMotoristas': 'Viagens por motorista',
    'viagens.bloco.rankingDestinos': 'Viagens por destino',
    'viagens.bloco.semDados': 'Sem dados no período.',
    'viagens.bloco.semVinculoDados': 'Nenhuma viagem do Protheus no período.',
    'viagens.bloco.etapas': 'Tempo por etapa',
    'viagens.bloco.etapasHint': 'Onde o relógio da viagem corre. A barra é a média; o traço, a mediana; a faixa clara vai até o p90.',
    'viagens.etapa.escalado': 'Escalado',
    'viagens.etapa.carregando': 'Carregamento',
    'viagens.etapa.transito': 'Trânsito',
    'viagens.etapa.descarregando': 'Descarga',
    'viagens.etapa.ciclo': 'Ciclo completo',
    'viagens.etapas.media': 'média',
    'viagens.etapas.mediana': 'mediana',
    'viagens.etapas.p90': 'p90',
    'viagens.etapas.max': 'máximo',
    'viagens.etapas.n': '{{count}} viagens',
    'viagens.etapas.abertas': '{{count}} em curso',
    'viagens.etapas.semEvento': '{{count}} viagens sem histórico ficam fora das medidas',
    'viagens.etapas.vazio': 'Nenhuma etapa fechada no período.',
    'viagens.bloco.distancia': 'Distância por dia',
    'viagens.bloco.distanciaHint': 'Quilômetro GPS das viagens medidas, pela data prevista da viagem.',
    'viagens.distancia.transito': 'em trânsito',
    'viagens.distancia.medidas': '{{count}} viagens medidas',
    'viagens.distancia.pendentes': '{{count}} ainda sem medida',
    'viagens.distancia.semVeiculo': '{{count}} sem cavalo',
    'viagens.distancia.vazio': 'Nenhuma viagem medida no período.',
    'viagens.bloco.porHora': 'Saídas e chegadas por hora',
    'viagens.bloco.porHoraHint': 'Saída é a entrada em trânsito; chegada é a entrada em descarregando.',
    'viagens.porHora.saidas': 'Saídas',
    'viagens.porHora.chegadas': 'Chegadas',
    'viagens.bloco.composicao': 'Frota por etapa ao longo do dia',
    'viagens.bloco.composicaoHint': 'Quantas viagens em cada status, de 10 em 10 minutos, reconstruído do histórico de eventos.',
    'viagens.composicao.semEvento': '{{count}} viagens sem histórico ficam fora da curva',
    'viagens.composicao.vazio': 'Nenhuma viagem com histórico neste dia.',
    'viagens.bloco.pipeline': 'Etapas agora',
    'viagens.bloco.pipelineHint': 'Quantas viagens estão em cada etapa da máquina neste instante.',
    'viagens.bloco.porPlaca': 'Por placa',
    'viagens.bloco.porMotorista': 'Por motorista',
    'viagens.grupo.contagemPlacas': '{{count}} placas',
    'viagens.grupo.contagemMotoristas': '{{count}} motoristas',
    'viagens.grupo.col.nome': 'Nome',
    'viagens.grupo.col.placa': 'Placa',
    'viagens.grupo.col.viagens': 'Viagens',
    'viagens.grupo.col.atendidas': 'Atend.',
    'viagens.grupo.col.naoAtendidas': 'Não at.',
    'viagens.grupo.col.km': 'Km',
    'viagens.grupo.col.transito': 'Trânsito',
    'viagens.grupo.col.descarga': 'Descarga',
    'viagens.grupo.col.ciclo': 'Ciclo',
    'viagens.grupo.col.motoristas': 'Motoristas',
    'viagens.grupo.col.placas': 'Placas',
    'viagens.grupo.hint': 'Médias das etapas fechadas e soma do quilômetro medido. Clique no cabeçalho para ordenar.',
    'viagens.grupo.vazio': 'Nenhum registro no período.',
    'viagens.serie.atendidas': 'Atendidas',
    'viagens.serie.naoAtendidas': 'Não atendidas',
    'viagens.serie.andamento': 'Em andamento',
    'viagens.serie.km': 'Km',
    'viagens.tooltip.viagens': '{{count}} viagens',
    'viagens.tooltip.total': 'Total',
  },
  en: {
    'viagens.title': 'Trips',
    'viagens.eyebrow': 'Logistics',
    'viagens.toggle.dia': 'Live day',
    'viagens.toggle.historico': 'History',
    'viagens.kpi.total': 'Trips',
    'viagens.kpi.atendidas': 'Attended',
    'viagens.kpi.naoAtendidas': 'Not attended',
    'viagens.kpi.emAndamento': 'In progress',
    'viagens.kpi.desvios': 'Deviations',
    'viagens.kpi.semVinculo': 'No HUB load',
    'viagens.kpi.semVinculoHint': 'Protheus trips without a matched HUB load, and so without measures',
    'viagens.kpi.km': 'Km driven',
    'viagens.kpi.kmHint': 'GPS distance of measured trips, in transit only. Unloading does not count kilometers',
    'viagens.kpi.transito': 'Avg. transit',
    'viagens.kpi.transitoHint': 'From leaving the origin to arriving at the destination, closed transits only',
    'viagens.kpi.descarga': 'Avg. unloading',
    'viagens.kpi.descargaHint': 'From arrival to release at the unit, excluding suspicious and batch-closed unloads',
    'viagens.kpi.ciclo': 'Avg. cycle',
    'viagens.kpi.cicloHint': 'From scheduling to Attended, attended trips only',
    'viagens.kpi.nfNoPrazo': 'Invoice request on time',
    'viagens.kpi.nfNoPrazoHint': 'Invoices requested before leaving the farm, out of {{count}} measured trips',
    'viagens.kpi.semMedida': 'No measure',
    'viagens.filtros.todos': 'All',
    'viagens.filtros.de': 'From',
    'viagens.filtros.ate': 'To',
    'viagens.filtros.busca': 'Trip, load, driver, customer…',
    'viagens.filtros.buscaLabel': 'Search',
    'viagens.filtros.cliente': 'Customer',
    'viagens.filtros.contrato': 'Contract',
    'viagens.filtros.dupla': 'Pair',
    'viagens.filtros.motorista': 'Driver',
    'viagens.filtros.servico': 'Service',
    'viagens.col.servico': 'Service',
    'viagens.servico.sem': 'No service',
    'viagens.servico.descricaoErp': 'ERP description',
    'viagens.servico.semDescricao': 'The trip came from the ERP without a service description',
    'viagens.servico.naoAlocada': 'Not allocated to a service in Records yet',
    'viagens.servico.porPadrao': 'No allocation in Records. The trip shows in the default service.',
    'viagens.filtros.statusHub': 'HUB status',
    'viagens.filtros.statusErp': 'ERP status',
    'viagens.filtros.hojeHint': 'The live day is always today',
    'viagens.col.data': 'Date',
    'viagens.col.dataHub': 'HUB date',
    'viagens.col.dataErp': 'ERP date',
    'viagens.data.semHub': 'Trip not recorded in the HUB. The period uses the ERP date',
    'viagens.col.frenteContrato': 'Front and contract',
    'viagens.col.frente': 'Front',
    'viagens.col.motorista': 'Driver',
    'viagens.col.placa': 'Plate',
    'viagens.col.carreta': 'Trailer',
    'viagens.col.statusHub': 'HUB status',
    'viagens.col.statusErp': 'ERP status',
    'viagens.col.viagemErp': 'ERP trip',
    'viagens.col.tempoUbs': 'UBS time',
    'viagens.ubs.preenchido': 'Filled',
    'viagens.ubs.pendente': 'Pending',
    'viagens.ubs.nao_se_aplica': 'Not applicable',
    'viagens.ubs.dica.preenchido': 'Protheus already has the UBS time of this trip.',
    'viagens.ubs.dica.pendente': 'Protheus has no valid UBS time for this trip. It enters the UBS time file once the unloading is measured up to Available.',
    'viagens.ubs.dica.nao_se_aplica': 'Only Ear corn trips have UBS time.',
    'viagens.arquivo.tempo_ubs.rotulo': 'Generate UBS time CSV',
    'viagens.arquivo.tempo_ubs.dica_one': 'Carries {{count}} Ear corn trip fulfilled in the HUB, with the UBS time empty in Protheus and the unloading measured up to Available.',
    'viagens.arquivo.tempo_ubs.dica_other': 'Carries {{count}} Ear corn trips fulfilled in the HUB, with the UBS time empty in Protheus and the unloading measured up to Available.',
    'viagens.arquivo.tempo_ubs.vazio': 'No trip in the filter is Ear corn fulfilled in the HUB, with the UBS time empty in Protheus and the unloading measured up to Available.',
    'viagens.arquivo.apontamento.rotulo': 'Generate trip log CSV',
    'viagens.arquivo.apontamento.dica_one': 'Carries {{count}} Ear corn trip open in Protheus and unloading or fulfilled in the HUB.',
    'viagens.arquivo.apontamento.dica_other': 'Carries {{count}} Ear corn trips open in Protheus and unloading or fulfilled in the HUB.',
    'viagens.arquivo.apontamento.vazio': 'No trip in the filter is Ear corn, open in Protheus and unloading or fulfilled in the HUB.',
    'viagens.arquivo.jaGeradas_one': '{{count}} of them already went out in a file, the last one generated by {{quem}} on {{quando}}. Protheus has not returned the data yet.',
    'viagens.arquivo.jaGeradas_other': '{{count}} of them already went out in a file, the last one generated by {{quem}} on {{quando}}. Protheus has not returned the data yet.',
    'viagens.arquivo.jaGeradasSemAutor_one': '{{count}} of them already went out in a file, the last one generated on {{quando}}. Protheus has not returned the data yet.',
    'viagens.arquivo.jaGeradasSemAutor_other': '{{count}} of them already went out in a file, the last one generated on {{quando}}. Protheus has not returned the data yet.',
    'viagens.col.destino': 'Destination',
    'viagens.col.dupla': 'Pair',
    'viagens.col.transito': 'Transit',
    'viagens.col.descarga': 'Unloading',
    'viagens.col.ciclo': 'Cycle',
    'viagens.col.kmVazio': 'Empty km',
    'viagens.col.kmCarregado': 'Loaded km',
    'viagens.col.kmErp': 'Protheus km',
    'viagens.col.otimizacao': 'Optimization',
    'viagens.km.semOtimizacao': 'No optimization',
    'viagens.km.semOtimizacaoDica': 'This trip is missing the Protheus km or the empty km.',
    'viagens.km.vazioSemMedida': 'Empty km is what the truck ran from the Available of the previous trip until it entered Transit, through Sent ahead, Scheduled and Loading. Time on Day off, Maintenance or Other services is left out. No measure when the tracker sent no position.',
    'viagens.km.erpDiferenca': 'Actual loaded {{real}}, difference {{delta}}',
    'viagens.km.erpSemComparacao': 'No loaded km measured to compare',
    'viagens.kpi.otimizacao': 'Km optimization',
    'viagens.kpi.otimizacaoDica': '{{n}} trips with Protheus and empty km measured',
    'viagens.otimizacao.titulo': 'Km optimization',
    'viagens.otimizacao.amostra': '{{count}} trips measured',
    'viagens.otimizacao.protheus': 'Protheus km',
    'viagens.otimizacao.vazioRotulo': 'Empty km',
    'viagens.otimizacao.pendentes': 'Trips still unmeasured',
    'viagens.otimizacao.negativo': 'Ran empty more than Protheus pays for.',
    'viagens.otimizacao.rodape': 'Optimization is the Protheus km minus the empty km. Empty is what the truck ran in Sent ahead, Scheduled and Loading, until it entered Transit.',
    'viagens.otimizacao.vazio': 'No trip in this period has both the Protheus km and the empty km measured.',
    'viagens.col.notaFiscal': 'Invoice request',
    'viagens.col.emissaoNf': 'Invoice issue',
    'viagens.nf.noPrazo': 'On time',
    'viagens.grupo.composicao': 'Composition',
    'viagens.grupo.status': 'Trip status',
    'viagens.grupo.medidas': 'Measures',
    'viagens.vazio': 'No trips in this view.',
    'viagens.relatorio.title': 'Report',
    'viagens.relatorio.hint': 'Times only for closed stages. Km of stages in progress is measured up to now. A dash means no measure, not zero.',
    'viagens.relatorio.count': '{{count}} trips',
    'viagens.relatorio.ocultas': '{{count}} without driver or plate are left out of the table',
    'viagens.bloco.statusHub': 'HUB status',
    'viagens.bloco.statusHubCentro': 'trips',
    'viagens.bloco.statusErp': 'ERP status',
    'viagens.bloco.semStatus': 'No status',
    'viagens.bloco.curvas': 'Trips per day',
    'viagens.bloco.curvasHint': 'By planned trip date. From bottom to top, attended, in progress from Scheduled to Unloading, not attended, and no status, which are the Protheus trips without a HUB load.',
    'viagens.bloco.rankingDuplas': 'Trips per pair',
    'viagens.bloco.rankingMotoristas': 'Trips per driver',
    'viagens.bloco.rankingDestinos': 'Trips per destination',
    'viagens.bloco.semDados': 'No data in the period.',
    'viagens.bloco.semVinculoDados': 'No Protheus trip in the period.',
    'viagens.bloco.etapas': 'Time per stage',
    'viagens.bloco.etapasHint': 'Where the trip clock runs. The bar is the mean; the tick, the median; the light band reaches the p90.',
    'viagens.etapa.escalado': 'Scheduled',
    'viagens.etapa.carregando': 'Loading',
    'viagens.etapa.transito': 'Transit',
    'viagens.etapa.descarregando': 'Unloading',
    'viagens.etapa.ciclo': 'Full cycle',
    'viagens.etapas.media': 'mean',
    'viagens.etapas.mediana': 'median',
    'viagens.etapas.p90': 'p90',
    'viagens.etapas.max': 'max',
    'viagens.etapas.n': '{{count}} trips',
    'viagens.etapas.abertas': '{{count}} running',
    'viagens.etapas.semEvento': '{{count}} trips without history are left out of the measures',
    'viagens.etapas.vazio': 'No closed stage in the period.',
    'viagens.bloco.distancia': 'Distance per day',
    'viagens.bloco.distanciaHint': 'GPS km of measured trips, by planned trip date.',
    'viagens.distancia.transito': 'in transit',
    'viagens.distancia.medidas': '{{count}} trips measured',
    'viagens.distancia.pendentes': '{{count}} still unmeasured',
    'viagens.distancia.semVeiculo': '{{count}} without a truck',
    'viagens.distancia.vazio': 'No trip measured in the period.',
    'viagens.bloco.porHora': 'Departures and arrivals per hour',
    'viagens.bloco.porHoraHint': 'A departure is entering transit; an arrival is entering unloading.',
    'viagens.porHora.saidas': 'Departures',
    'viagens.porHora.chegadas': 'Arrivals',
    'viagens.bloco.composicao': 'Fleet per stage through the day',
    'viagens.bloco.composicaoHint': 'How many trips in each status, every 10 minutes, rebuilt from the event history.',
    'viagens.composicao.semEvento': '{{count}} trips without history are left out of the curve',
    'viagens.composicao.vazio': 'No trip with history on this day.',
    'viagens.bloco.pipeline': 'Stages now',
    'viagens.bloco.pipelineHint': 'How many trips sit in each stage of the machine right now.',
    'viagens.bloco.porPlaca': 'By plate',
    'viagens.bloco.porMotorista': 'By driver',
    'viagens.grupo.contagemPlacas': '{{count}} plates',
    'viagens.grupo.contagemMotoristas': '{{count}} drivers',
    'viagens.grupo.col.nome': 'Name',
    'viagens.grupo.col.placa': 'Plate',
    'viagens.grupo.col.viagens': 'Trips',
    'viagens.grupo.col.atendidas': 'Att.',
    'viagens.grupo.col.naoAtendidas': 'Not att.',
    'viagens.grupo.col.km': 'Km',
    'viagens.grupo.col.transito': 'Transit',
    'viagens.grupo.col.descarga': 'Unloading',
    'viagens.grupo.col.ciclo': 'Cycle',
    'viagens.grupo.col.motoristas': 'Drivers',
    'viagens.grupo.col.placas': 'Plates',
    'viagens.grupo.hint': 'Means of closed stages and the sum of measured km. Click a header to sort.',
    'viagens.grupo.vazio': 'No record in the period.',
    'viagens.serie.atendidas': 'Attended',
    'viagens.serie.naoAtendidas': 'Not attended',
    'viagens.serie.andamento': 'In progress',
    'viagens.serie.km': 'Km',
    'viagens.tooltip.viagens': '{{count}} trips',
    'viagens.tooltip.total': 'Total',
  },
  es: {
    'viagens.title': 'Viajes',
    'viagens.eyebrow': 'Logística',
    'viagens.toggle.dia': 'Día en vivo',
    'viagens.toggle.historico': 'Histórico',
    'viagens.kpi.total': 'Viajes',
    'viagens.kpi.atendidas': 'Atendidos',
    'viagens.kpi.naoAtendidas': 'No atendidos',
    'viagens.kpi.emAndamento': 'En curso',
    'viagens.kpi.desvios': 'Desvíos',
    'viagens.kpi.semVinculo': 'Sin carga en el HUB',
    'viagens.kpi.semVinculoHint': 'Viajes de Protheus sin carga equiparada en el HUB, y por eso sin medidas',
    'viagens.kpi.km': 'Km recorridos',
    'viagens.kpi.kmHint': 'Distancia GPS de los viajes medidos, solo en tránsito. La descarga no cuenta kilómetros',
    'viagens.kpi.transito': 'Tránsito medio',
    'viagens.kpi.transitoHint': 'De la salida del origen a la llegada al destino, solo tránsitos cerrados',
    'viagens.kpi.descarga': 'Descarga media',
    'viagens.kpi.descargaHint': 'De la llegada a la liberación en la unidad, sin las descargas sospechosas ni las cerradas en lote',
    'viagens.kpi.ciclo': 'Ciclo medio',
    'viagens.kpi.nfNoPrazo': 'Solicitud de NF a tiempo',
    'viagens.kpi.nfNoPrazoHint': 'Notas pedidas antes de salir de la finca, sobre {{count}} viajes medidos',
    'viagens.kpi.cicloHint': 'De la escala al Atendido, solo viajes atendidos',
    'viagens.kpi.semMedida': 'Sin medida',
    'viagens.filtros.todos': 'Todos',
    'viagens.filtros.de': 'Desde',
    'viagens.filtros.ate': 'Hasta',
    'viagens.filtros.busca': 'Viaje, carga, conductor, cliente…',
    'viagens.filtros.buscaLabel': 'Búsqueda',
    'viagens.filtros.cliente': 'Cliente',
    'viagens.filtros.contrato': 'Contrato',
    'viagens.filtros.dupla': 'Dupla',
    'viagens.filtros.motorista': 'Conductor',
    'viagens.filtros.servico': 'Servicio',
    'viagens.col.servico': 'Servicio',
    'viagens.servico.sem': 'Sin servicio',
    'viagens.servico.descricaoErp': 'Descripción en el ERP',
    'viagens.servico.semDescricao': 'El viaje llegó del ERP sin descripción de servicio',
    'viagens.servico.naoAlocada': 'Todavía no asignada a un servicio en Registros',
    'viagens.servico.porPadrao': 'Sin asignación en Registros. El viaje aparece en el servicio predeterminado.',
    'viagens.filtros.statusHub': 'Estado HUB',
    'viagens.filtros.statusErp': 'Estado ERP',
    'viagens.filtros.hojeHint': 'El día en vivo siempre es hoy',
    'viagens.col.data': 'Fecha',
    'viagens.col.dataHub': 'Fecha HUB',
    'viagens.col.dataErp': 'Fecha ERP',
    'viagens.data.semHub': 'Viaje sin registro en el HUB. El período usa la Fecha ERP',
    'viagens.col.frenteContrato': 'Frente y contrato',
    'viagens.col.frente': 'Frente',
    'viagens.col.motorista': 'Conductor',
    'viagens.col.placa': 'Placa',
    'viagens.col.carreta': 'Remolque',
    'viagens.col.statusHub': 'Estado HUB',
    'viagens.col.statusErp': 'Estado ERP',
    'viagens.col.viagemErp': 'Viaje ERP',
    'viagens.col.tempoUbs': 'Tiempo UBS',
    'viagens.ubs.preenchido': 'Completado',
    'viagens.ubs.pendente': 'Pendiente',
    'viagens.ubs.nao_se_aplica': 'No aplica',
    'viagens.ubs.dica.preenchido': 'Protheus ya tiene el Tiempo UBS de este viaje.',
    'viagens.ubs.dica.pendente': 'Protheus no tiene un Tiempo UBS válido para este viaje. Entra en el archivo de Tiempo UBS cuando la descarga esté medida hasta el Disponible.',
    'viagens.ubs.dica.nao_se_aplica': 'Solo el viaje de Mazorca tiene Tiempo UBS.',
    'viagens.arquivo.tempo_ubs.rotulo': 'Generar CSV Tiempo UBS',
    'viagens.arquivo.tempo_ubs.dica_one': 'Lleva {{count}} viaje de Mazorca atendido en el HUB, con el Tiempo UBS vacío en Protheus y la descarga medida hasta el Disponible.',
    'viagens.arquivo.tempo_ubs.dica_other': 'Lleva {{count}} viajes de Mazorca atendidos en el HUB, con el Tiempo UBS vacío en Protheus y la descarga medida hasta el Disponible.',
    'viagens.arquivo.tempo_ubs.vazio': 'Ningún viaje del filtro es de Mazorca atendido en el HUB, con el Tiempo UBS vacío en Protheus y la descarga medida hasta el Disponible.',
    'viagens.arquivo.apontamento.rotulo': 'Generar CSV Registro de Viaje',
    'viagens.arquivo.apontamento.dica_one': 'Lleva {{count}} viaje de Mazorca abierto en Protheus y descargando o atendido en el HUB.',
    'viagens.arquivo.apontamento.dica_other': 'Lleva {{count}} viajes de Mazorca abiertos en Protheus y descargando o atendidos en el HUB.',
    'viagens.arquivo.apontamento.vazio': 'Ningún viaje del filtro es de Mazorca abierto en Protheus y descargando o atendido en el HUB.',
    'viagens.arquivo.jaGeradas_one': '{{count}} de ellos ya salió en archivo, el último generado por {{quem}} el {{quando}}. Protheus todavía no devolvió el dato.',
    'viagens.arquivo.jaGeradas_other': '{{count}} de ellos ya salieron en archivo, el último generado por {{quem}} el {{quando}}. Protheus todavía no devolvió el dato.',
    'viagens.arquivo.jaGeradasSemAutor_one': '{{count}} de ellos ya salió en archivo, el último generado el {{quando}}. Protheus todavía no devolvió el dato.',
    'viagens.arquivo.jaGeradasSemAutor_other': '{{count}} de ellos ya salieron en archivo, el último generado el {{quando}}. Protheus todavía no devolvió el dato.',
    'viagens.col.destino': 'Destino',
    'viagens.col.dupla': 'Dupla',
    'viagens.col.transito': 'Tránsito',
    'viagens.col.descarga': 'Descarga',
    'viagens.col.ciclo': 'Ciclo',
    'viagens.col.kmVazio': 'KM vacío',
    'viagens.col.kmCarregado': 'KM cargado',
    'viagens.col.kmErp': 'KM Protheus',
    'viagens.col.otimizacao': 'Optimización',
    'viagens.km.semOtimizacao': 'Sin optimización',
    'viagens.km.semOtimizacaoDica': 'Falta el KM Protheus o el KM vacío de este viaje.',
    'viagens.km.vazioSemMedida': 'El KM vacío es lo que el camión recorrió desde el Disponible del viaje anterior hasta entrar en Tránsito, pasando por Adelantado, Programado y Cargando. Queda fuera el tiempo en Descanso, Mantenimiento u Otros servicios. Sin medida cuando el rastreador no envió posición.',
    'viagens.km.erpDiferenca': 'Cargado real {{real}}, diferencia {{delta}}',
    'viagens.km.erpSemComparacao': 'Sin KM cargado medido para comparar',
    'viagens.kpi.otimizacao': 'Optimización de KM',
    'viagens.kpi.otimizacaoDica': '{{n}} viajes con KM Protheus y KM vacío medidos',
    'viagens.otimizacao.titulo': 'Optimización de KM',
    'viagens.otimizacao.amostra': '{{count}} viajes medidos',
    'viagens.otimizacao.protheus': 'KM Protheus',
    'viagens.otimizacao.vazioRotulo': 'KM vacío',
    'viagens.otimizacao.pendentes': 'Viajes aún sin medida',
    'viagens.otimizacao.negativo': 'Recorrió vacío más de lo que Protheus paga.',
    'viagens.otimizacao.rodape': 'Optimización es el KM Protheus menos el KM vacío. Vacío es lo que el camión recorrió en Adelantado, Programado y Cargando, hasta entrar en Tránsito.',
    'viagens.otimizacao.vazio': 'Ningún viaje del período tiene el KM Protheus y el KM vacío medidos.',
    'viagens.col.notaFiscal': 'Solicitud de NF',
    'viagens.col.emissaoNf': 'Emisión NF',
    'viagens.nf.noPrazo': 'A tiempo',
    'viagens.grupo.composicao': 'Composición',
    'viagens.grupo.status': 'Estado del viaje',
    'viagens.grupo.medidas': 'Medidas',
    'viagens.vazio': 'Ningún viaje en este recorte.',
    'viagens.relatorio.title': 'Informe',
    'viagens.relatorio.hint': 'Tiempos solo de las etapas cerradas. El km de las etapas en curso se mide hasta ahora. El guion es sin medida, no cero.',
    'viagens.relatorio.count': '{{count}} viajes',
    'viagens.relatorio.ocultas': '{{count}} sin conductor ni placa quedan fuera de la tabla',
    'viagens.bloco.statusHub': 'Estado HUB',
    'viagens.bloco.statusHubCentro': 'viajes',
    'viagens.bloco.statusErp': 'Estado ERP',
    'viagens.bloco.semStatus': 'Sin estado',
    'viagens.bloco.curvas': 'Viajes por día',
    'viagens.bloco.curvasHint': 'Por la fecha prevista del viaje. De abajo hacia arriba, atendidos, en curso de Programado a Descargando, no atendidos y sin estado, que son los viajes de Protheus sin carga en el HUB.',
    'viagens.bloco.rankingDuplas': 'Viajes por dupla',
    'viagens.bloco.rankingMotoristas': 'Viajes por conductor',
    'viagens.bloco.rankingDestinos': 'Viajes por destino',
    'viagens.bloco.semDados': 'Sin datos en el período.',
    'viagens.bloco.semVinculoDados': 'Ningún viaje de Protheus en el período.',
    'viagens.bloco.etapas': 'Tiempo por etapa',
    'viagens.bloco.etapasHint': 'Dónde corre el reloj del viaje. La barra es la media; el trazo, la mediana; la franja clara llega al p90.',
    'viagens.etapa.escalado': 'Programado',
    'viagens.etapa.carregando': 'Carga',
    'viagens.etapa.transito': 'Tránsito',
    'viagens.etapa.descarregando': 'Descarga',
    'viagens.etapa.ciclo': 'Ciclo completo',
    'viagens.etapas.media': 'media',
    'viagens.etapas.mediana': 'mediana',
    'viagens.etapas.p90': 'p90',
    'viagens.etapas.max': 'máximo',
    'viagens.etapas.n': '{{count}} viajes',
    'viagens.etapas.abertas': '{{count}} en curso',
    'viagens.etapas.semEvento': '{{count}} viajes sin historial quedan fuera de las medidas',
    'viagens.etapas.vazio': 'Ninguna etapa cerrada en el período.',
    'viagens.bloco.distancia': 'Distancia por día',
    'viagens.bloco.distanciaHint': 'Km GPS de los viajes medidos, por la fecha prevista del viaje.',
    'viagens.distancia.transito': 'en tránsito',
    'viagens.distancia.medidas': '{{count}} viajes medidos',
    'viagens.distancia.pendentes': '{{count}} aún sin medida',
    'viagens.distancia.semVeiculo': '{{count}} sin camión',
    'viagens.distancia.vazio': 'Ningún viaje medido en el período.',
    'viagens.bloco.porHora': 'Salidas y llegadas por hora',
    'viagens.bloco.porHoraHint': 'Salida es entrar en tránsito; llegada es entrar en descarga.',
    'viagens.porHora.saidas': 'Salidas',
    'viagens.porHora.chegadas': 'Llegadas',
    'viagens.bloco.composicao': 'Flota por etapa a lo largo del día',
    'viagens.bloco.composicaoHint': 'Cuántos viajes en cada estado, cada 10 minutos, reconstruido del historial de eventos.',
    'viagens.composicao.semEvento': '{{count}} viajes sin historial quedan fuera de la curva',
    'viagens.composicao.vazio': 'Ningún viaje con historial en este día.',
    'viagens.bloco.pipeline': 'Etapas ahora',
    'viagens.bloco.pipelineHint': 'Cuántos viajes están en cada etapa de la máquina en este instante.',
    'viagens.bloco.porPlaca': 'Por placa',
    'viagens.bloco.porMotorista': 'Por conductor',
    'viagens.grupo.contagemPlacas': '{{count}} placas',
    'viagens.grupo.contagemMotoristas': '{{count}} conductores',
    'viagens.grupo.col.nome': 'Nombre',
    'viagens.grupo.col.placa': 'Placa',
    'viagens.grupo.col.viagens': 'Viajes',
    'viagens.grupo.col.atendidas': 'Atend.',
    'viagens.grupo.col.naoAtendidas': 'No at.',
    'viagens.grupo.col.km': 'Km',
    'viagens.grupo.col.transito': 'Tránsito',
    'viagens.grupo.col.descarga': 'Descarga',
    'viagens.grupo.col.ciclo': 'Ciclo',
    'viagens.grupo.col.motoristas': 'Conductores',
    'viagens.grupo.col.placas': 'Placas',
    'viagens.grupo.hint': 'Medias de las etapas cerradas y suma del km medido. Clic en el encabezado para ordenar.',
    'viagens.grupo.vazio': 'Ningún registro en el período.',
    'viagens.serie.atendidas': 'Atendidos',
    'viagens.serie.naoAtendidas': 'No atendidos',
    'viagens.serie.andamento': 'En curso',
    'viagens.serie.km': 'Km',
    'viagens.tooltip.viagens': '{{count}} viajes',
    'viagens.tooltip.total': 'Total',
  },
}
